import './style.css';

import DocumentTitle from 'bz-core-controls/controls/document-title';
import PageHeader from 'bz-core-controls/controls/page-header';
import type { PropsWithChildren, ReactElement } from 'react';
import React from 'react';
import LoadingPanel from '../layout/loading-panel';

interface IDesktopBaseProps extends PropsWithChildren {
  loading: boolean;
  title: string;
  className?: string;
  backBtn?: ReactElement;
  headerContent?: ReactElement;
  additionalContent?: ReactElement;

  classes?: any; // Assuming classes prop is passed to PageHeader
}

class DesktopBase extends React.Component<IDesktopBaseProps> {
  render() {
    let {
      loading,
      title,
      className,
      backBtn,
      save,
      headerContent,
      additionalContent,
      children,
      classes
    } = this.props;

    return (
      <LoadingPanel loading={loading}>
        <DocumentTitle title={'TM3 > ' + title}>
          <div className={`nowrap desktop-page flex-row ${className || ''}`}>
            <div className="flex-both flex-column nowrap">
              <div className="flex-none">
                <PageHeader classes={classes} title={title} button={backBtn}>
                  {headerContent ? headerContent : null}
                </PageHeader>
              </div>
              <div className="flex-both flex-column nowrap">{children ? children : null}</div>
            </div>
            {additionalContent ? additionalContent : null}
          </div>
        </DocumentTitle>
      </LoadingPanel>
    );
  }
}

export default DesktopBase;
